var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f39200",
    d: "M7.13 5.484a.486.486 0 1 1 .971 0V6.67a2.23 2.23 0 0 1-.657 1.58 2.23 2.23 0 0 1-1.58.657H2.7a2.23 2.23 0 0 1-1.58-.657 2.23 2.23 0 0 1-.657-1.58V5.484a.486.486 0 1 1 .972 0V6.67c0 .348.142.664.372.893.23.23.546.373.893.373h3.164c.347 0 .664-.143.893-.373.23-.23.372-.545.372-.893z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f39200",
    d: "M4.768 1.787v4.725a.486.486 0 1 1-.972 0V1.787l-.922.922a.486.486 0 0 1-.687-.687L3.94.27c.19-.19.497-.19.687 0l1.75 1.75a.486.486 0 0 1-.686.688z"
  })));
};
export default SvgUpload;